<template>
  <div class="course-data-selector">
    <weui-group title="空余时段分布：">
      <weui-cell
        v-for="d in available_dates"
        :key="d.date"
        :link="!!d.available"
        :text="formatDate(d.date)"
        :tips="d.available ? null : '安排已满'"
        @click="selectDate(d)"
      />
    </weui-group>
    <weui-group>
      <weui-button-cell @click="loadDates">展示更多空闲时段</weui-button-cell>
    </weui-group>
  </div>
</template>

<script>
import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';
import mixinFormatters from '@/mixins/formatters';
import { ROUTE_COURSE_CREATE_TIME_SELECTOR } from '@/router/names';
import mixinDraft from './draft.mixin';

export default {
    created() {
        this.fetchAvailableDates();
    },
    methods: {
        loadDates() {
            this.fetchAvailableDates();
        },
        selectDate(d) {
            if (!d.available) {
                return;
            }
            this.fillDraft({
                date: d.date,
            });
            this.$router.replace({
                name: ROUTE_COURSE_CREATE_TIME_SELECTOR,
            });
        },
    },
    mixins: [
        mixinDraft,
        mixinFormatters,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
    },
};
</script>

<style lang="scss" scoped>
.course-date {
    display: flex;
    align-content: space-between;

    .date {
        flex: auto;
    }

    .text-tip {
        flex: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/course/DateSelector.vue